// src/lib/shellApp.ts

type ShellAppResult<T = any> = {
  ok: boolean;
  data?: T;
  error?: string;
};

declare global {
  interface Window {
    ShellApp?: {
      print: (payload: any) => Promise<ShellAppResult>;
      pay: (payload: any) => Promise<ShellAppResult>;
      ping: () => Promise<ShellAppResult>;
    };
  }
}

/**
 * Check if Flutter ShellApp bridge is available
 * This is our ONLY tablet detection mechanism
 */
export const isShellAppAvailable = (): boolean => {
  return typeof window !== "undefined" && !!window.ShellApp;
};

/**
 * Optional health check
 */
export const pingShellApp = async () => {
  if (!isShellAppAvailable()) return null;
  return await window.ShellApp!.ping();
};

/**
 * Print receipt or PDF
 */
export const shellPrint = async (payload: any) => {
  if (!isShellAppAvailable()) {
    throw new Error("Printing is only available on the tablet app");
  }
  return await window.ShellApp!.print(payload);
};

/**
 * Pay via Stripe Terminal (card reader)
 */
export const shellPay = async (payload: any) => {
  if (!isShellAppAvailable()) {
    throw new Error("Card payment is only available on the tablet app");
  }
  return await window.ShellApp!.pay(payload);
};
